import React from 'react';
import './Metering.scss'
import { Lists, HeaderSwiper, TwoColList } from '@/components/mixins'
import '../../common/common.scss'
import { RelatedCases } from '@/components'
class Metering extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      headerDataLists: [
        { imgPath: require("img/EcosphereDetails/meteringbanner.png"), imgHDPath: `${require("img/EcosphereDetails/meteringbanner.png")} 1x,${require("img/EcosphereDetails/meteringbanner@2x.png")} 2x,${require("img/EcosphereDetails/meteringbanner@3x.png")} 3x`, attachURL: "/" }
      ],
      dataLists: [
        {
          title: '工程造价标准化',
          data: '为了改变造价咨询行业传统模式下成果不统一、工期不可控、质量不稳定的局面，青矩经过多年的研究，率先推出工程造价标准化作业模式。',
          imgPath: require("img/EcosphereDetails/meteringicon01.png"), imgHDPath: `${require("img/EcosphereDetails/meteringicon01.png")} 1x,${require("img/EcosphereDetails/meteringicon01@2x.png")} 2x,${require("img/EcosphereDetails/meteringicon01@3x.png")} 3x`
        },
        {
          title: '服务特色',
          data: '标准化工程造价采取简单、统一、协调、优化的原则，通过专业化、流程化思维，运用信息化手段，以技术标准为核心，以管理标准为支持，全面实施流水线标准化协同作业模式，从而保障工程计量与工程计价服务的精准高效。',
          imgPath: require("img/EcosphereDetails/meteringicon02.png"), imgHDPath: `${require("img/EcosphereDetails/meteringicon02.png")} 1x,${require("img/EcosphereDetails/meteringicon02@2x.png")} 2x,${require("img/EcosphereDetails/meteringicon02@3x.png")} 3x`
        },
        {
          title: '服务优势',
          data: '标准化工程造价通过组织创新、流程创新、技术创新，全面实施流水线标准化协同作业模式，大幅提升工程造价咨询的工作速度和质量精度，确保服务的及时性和可靠性，为客户提供高性价比的工程造价基础服务产品。借助互联网+、BIM、大数据、人工智能等信息化技术，逐步实现工程造价咨询基础业务智能化作业。',
          imgPath: require("img/EcosphereDetails/meteringicon03.png"), imgHDPath: `${require("img/EcosphereDetails/meteringicon03.png")} 1x,${require("img/EcosphereDetails/meteringicon03@2x.png")} 2x`
        }
      ],
      ColIconData: [
        {
          imgPath: require("img/EcosphereDetails/meteringpic01.png"), imgHDPath: `${require("img/EcosphereDetails/meteringpic01.png")} 1x,${require("img/EcosphereDetails/meteringpic01@2x.png")} 2x`,
          title: '钢筋算量'
        },
        {
          imgPath: require("img/EcosphereDetails/meteringpic02.png"), imgHDPath: `${require("img/EcosphereDetails/meteringpic02.png")} 1x,${require("img/EcosphereDetails/meteringpic02@2x.png")} 2x`,
          title: '土建算量'
        },
        {
          imgPath: require("img/EcosphereDetails/meteringpic03.png"), imgHDPath: `${require("img/EcosphereDetails/meteringpic03.png")} 1x,${require("img/EcosphereDetails/meteringpic03@2x.png")} 2x`,
          title: '安装算量'
        },
        {
          imgPath: require("img/EcosphereDetails/meteringpic04.png"), imgHDPath: `${require("img/EcosphereDetails/meteringpic04.png")} 1x,${require("img/EcosphereDetails/meteringpic04@2x.png")} 2x`,
          title: '清单编制'
        },
        {
          imgPath: require("img/EcosphereDetails/meteringpic05.png"), imgHDPath: `${require("img/EcosphereDetails/meteringpic05.png")} 1x,${require("img/EcosphereDetails/meteringpic05@2x.png")} 2x`,
          title: '招标控制价'
        },

        {
          imgPath: require("img/EcosphereDetails/js.png"), imgHDPath: `${require("img/EcosphereDetails/js.png")} 1x,${require("img/EcosphereDetails/js@2x.png")} 2x`,
          title: '结算审核'
        },
      ],
      caseList: [
        { imgs: require("img/EcosphereDetails/meteringcase01.png"), name: "西北地区航站楼项目" },
        { imgs: require("img/EcosphereDetails/meteringcase02.png"), name: "华东地区乐园项目" },
        { imgs: require("img/EcosphereDetails/meteringcase03.png"), name: "华东地区商业综合体" },
        { imgs: require("img/EcosphereDetails/meteringcase04.png"), name: "红星国际广场" },
        { imgs: require("img/EcosphereDetails/meteringcase05.png"), name: " 马来西亚森林城市项目" },
      ]
    }
  }
  render() {
    return (
      <main>
        <HeaderSwiper headerDataLists={this.state.headerDataLists}></HeaderSwiper>
        <div className="Metering">
          <h5 className="product-title">产品布局</h5>
          <TwoColList ColIconData={this.state.ColIconData}></TwoColList>
          <h5 className='product-title'>服务介绍</h5>
          <Lists dataLists={this.state.dataLists}></Lists>
          <RelatedCases caseList={this.state.caseList} id={'metering'} />
        </div>
      </main>
    )
  }
}
export default Metering
